module.exports = __webpack_public_path__ + "images/LOGO_Wappen_RZ_MM-2db2d8a2285c8874ff4445ed0ecbd710.png";